import { Controller } from '@hotwired/stimulus';

// The /todo hero demo: the Automated To-Do List in miniature. Typing a task adds a
// row with a checkbox, ticking it writes today's date, and the x removes the row,
// the same three things the sheet's script does.
export default class extends Controller {
  static targets = ['list', 'input', 'done', 'total'];

  connect() {
    this.render();
  }

  add(event) {
    event.preventDefault();
    const text = this.inputTarget.value.trim();
    if (!text) return;
    const row = this.listTarget.querySelector('template').content.firstElementChild.cloneNode(true);
    row.querySelector('[data-task]').textContent = text;
    row.classList.add('is-new');
    this.listTarget.appendChild(row);
    setTimeout(() => row.classList.remove('is-new'), 600);
    this.inputTarget.value = '';
    this.render();
  }

  toggle(event) {
    const row = event.target.closest('[data-row]');
    const date = row.querySelector('[data-date]');
    date.textContent = event.target.checked ? new Date().toLocaleDateString() : '';
    row.classList.toggle('is-done', event.target.checked);
    this.render();
  }

  remove(event) {
    event.target.closest('[data-row]').remove();
    this.render();
  }

  render() {
    const rows = this.listTarget.querySelectorAll('[data-row]');
    const done = this.listTarget.querySelectorAll('[data-row] input:checked');
    this.doneTargets.forEach((el) => { el.textContent = done.length; });
    this.totalTargets.forEach((el) => { el.textContent = rows.length; });
  }
}
